const images = {
    analytics: require('./images/analytics.png'),
    finance: require('./images/finance.png'),
    resume: require('./images/resume.png'),
    review: require('./images/review.png'),
    coming_soon: require('./images/coming_soon.png'),
    target: require('./images/target.png'),
    server_error: require('./images/server_error.png'),
    refresh: require('./images/refresh.png'),
    icons: {
        tab_customer: require('./icons/tab_customer.png'),
        tab_finance: require('./icons/tab_finance.png'),
        tab_home: require('./icons/tab_home.png'),
        tab_process: require('./icons/tab_process.png'),
        tab_team: require('./icons/tab_team.png'),
        icon_setting: require('./icons/icon_setting.png'),
        icon_person: require('./icons/icon_person.png'),
        icon_bus: require('./icons/icon_bus.png'),
        icon_coin: require('./icons/icon_coin.png'),
        icon_coin: require('./icons/icon_coin.png'),
        icon_money: require('./icons/icon_money.png'),
        icon_seat_1: require('./icons/icon_seat_1.png'),
        icon_seat_2: require('./icons/icon_seat_2.png'),
        icon_value: require('./icons/icon_value.png'),
        icon_down: require('./icons/icon_down.png'),
        icon_arrow_up: require('./icons/icon_arrow_up.png'),
        star_full: require('./icons/star_full.png'),
        star_empty: require('./icons/star_empty.png'),
        star_quarter: require('./icons/star_quarter.png'),
        star_half: require('./icons/star_half.png'),
        star_more_half: require('./icons/star_more_half.png'),
        icon_presentation: require('./icons/icon_presentation.png'),
        icon_driver: require('./icons/icon_driver.png'),
        icon_team: require('./icons/icon_team.png'),
        icon_hostess: require('./icons/icon_hostess.png'),
    },
};

export default images